
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5bc7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5bc7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $88cece5baea9bf00$exports = {};
$parcel$extendImportMap({
    "da4Ek": "service-worker.js"
});

/// <reference lib="esnext" />
/// <reference no-default-lib="true"/>
/// <reference lib="dom" />
const $eb3c9524e29369ef$export$10de7d815fa48757 = "PING";
const $eb3c9524e29369ef$export$722418a560ba0645 = "INIT_PORT";
const $eb3c9524e29369ef$export$51e82cdd7353a0e1 = "REGISTER";
const $eb3c9524e29369ef$export$4bf05b02be91f13a = "READY";
const $eb3c9524e29369ef$export$4a991c87e640ef77 = "RESET";
const $eb3c9524e29369ef$export$4714ec563ac852dc = "HARD_RESET";
const $eb3c9524e29369ef$export$261422280c63b22 = "HMR";
const $eb3c9524e29369ef$export$1b56cc494043d9bf = "PREVIEW";
const $eb3c9524e29369ef$export$5f7219e25ecb1bd2 = "RELOAD";
const $eb3c9524e29369ef$export$da4155ec26ff194 = "WORKFLOW";
const $eb3c9524e29369ef$export$4d7531043d08c9ba = "NOTIFY";


let $7c32f7160f99fe79$var$cachedFiles = null;
function $7c32f7160f99fe79$var$sendMessageToSW(sw, data) {
    return new Promise((resolve)=>{
        const messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = (event)=>{
            resolve(event.data);
        };
        sw.postMessage(data, [
            messageChannel.port2
        ]);
    });
}
var $77197f19fc13d742$exports = {};
$77197f19fc13d742$exports = $parcel$resolve("da4Ek");


navigator.serviceWorker.register($77197f19fc13d742$exports, {
    scope: "./",
    updateViaCache: "imports"
}).then((sw)=>{
    console.log("preview: Service Worker Registered, sending ready");
    window.parent?.postMessage({
        type: (0, $eb3c9524e29369ef$export$4bf05b02be91f13a)
    }, "*");
    if (sw.active && $7c32f7160f99fe79$var$cachedFiles) {
        console.log("preview: sending cached files to service worker");
        $7c32f7160f99fe79$var$sendMessageToSW(sw.active, {
            type: "REGISTER",
            files: $7c32f7160f99fe79$var$cachedFiles
        }).then($7c32f7160f99fe79$var$handleSWResponse);
    }
}).catch((err)=>{
    console.log("preview: Service Worker Failed to Register", err);
});
function $7c32f7160f99fe79$var$handleSWResponse(data) {
    switch(data.type){
        case 0, $eb3c9524e29369ef$export$4bf05b02be91f13a:
            console.log("preview: sending ready to editor bc in vanilla mode");
            window.parent?.postMessage({
                type: (0, $eb3c9524e29369ef$export$4bf05b02be91f13a)
            }, "*");
            break;
        case 0, $eb3c9524e29369ef$export$261422280c63b22:
            console.log("got HMR message from vanilla preview");
            window.location.reload();
            break;
        default:
            console.log("preview: vanilla page received unknown message type:", data);
            break;
    }
}
window.addEventListener("message", $7c32f7160f99fe79$var$handleMessage);
async function $7c32f7160f99fe79$var$handleMessage(event) {
    const data = event.data;
    switch(data.type){
        case 0, $eb3c9524e29369ef$export$4714ec563ac852dc:
        case 0, $eb3c9524e29369ef$export$4a991c87e640ef77:
            console.log("preview: sending reset to service worker");
            window.location.reload();
            break;
        case 0, $eb3c9524e29369ef$export$4bf05b02be91f13a:
            console.log("preview: got ready from editor? I don't think we need this");
            window.location.reload();
            break;
        case 0, $eb3c9524e29369ef$export$51e82cdd7353a0e1:
            try {
                if (data.files) {
                    if (data.ts) {
                        const now = Date.now();
                        console.log(`vanilla got register, took ${now - data.ts}ms`);
                    }
                    const transferables = Object.values(data.files).filter((file)=>file.byteLength !== 0);
                    if (transferables.length > 0) {
                        const reg = await navigator.serviceWorker.ready;
                        const sw = reg.active;
                        if (sw) $7c32f7160f99fe79$var$sendMessageToSW(sw, {
                            type: "REGISTER",
                            files: data.files
                        }).then($7c32f7160f99fe79$var$handleSWResponse);
                        else {
                            console.log("caching files!", data.files);
                            $7c32f7160f99fe79$var$cachedFiles = data.files;
                        }
                    } else console.log("preview: no files to send to service worker");
                }
            } catch (err) {
                console.log("register error", err);
            }
            break;
        default:
            console.log("preview: page received unknown message type:", data);
            break;
    }
}


//# sourceMappingURL=repo.74119518.js.map
